import { cooDashboardSourceHtml } from '../fixtures/pocDashboardSource';
import { parseCooSourceHtml } from '../../coo-dashboard/utils/parseCooSourceHtml';

const pocDashboardData = parseCooSourceHtml(cooDashboardSourceHtml);

export default pocDashboardData;
